<template>
  <v-container>
    <v-responsive
      class="mx-auto px-3 px-md-12"
      max-width="750"
    >
      <v-container class="text-center">
        <v-row justify="center">
          <v-col
            cols="12"
            class="pa-4"
          >
            <h1>Annaliis {{ annaliisVersion }} Downloads</h1>
            <download-buttons />
          </v-col>

          <v-col
            cols="12"
            class="pa-4"
          >
            <h1>MES Arp {{ mesArpVersion }} Downloads</h1>
            <mes-arp-download-buttons />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </v-container>
</template>
  <script>
  import DownloadButtons from './DownloadButtons.vue'
  import MesArpDownloadButtons from './MesArpDownloadButtons.vue'
  export default {
    components: {
      DownloadButtons,
      MesArpDownloadButtons
    },
    data () {
      return {
        annaliisVersion: '1.2.0',
        mesArpVersion: '1.0.0'
      }
    },
  }
  </script>
